<template>
  <div class="events">
    <div class="top">
      <div class="imte__bag">Events</div>
      <div class="imte__min">同门会</div>
    </div>
    <div class="content">
      <Tabs type="line" :value="currentTabs" @on-click="tabsChange">
        <TabPane label="首页" icon="ios-paper" name="index">
          <div class="title__box">
            <h2>苏成教授同门会</h2>
          </div>
          <div class="lis__box">
            <Row :gutter="48">
              <Col :span="16">
                <Card :bordered="false" :padding="0" dis-hover>
                  <img :src="newestImg" alt="" width="100%" height="400px" />
                </Card>
              </Col>
              <Col :span="8">
                <Card :padding="0" style="height:400px;" dis-hover>
                  <template #title>
                    同门资讯
                  </template>
                  <template #extra>
                    <a href="#" @click.prevent="more(1)">
                      更多
                    </a>
                  </template>
                  <List>
                    <ListItem v-for="(item, index) in list1" :key="index">
                      <ListItemMeta
                        :title="item.date"
                        :description="item.description"
                      />
                    </ListItem>
                  </List>
                </Card>
              </Col>
            </Row>
            <Row :gutter="48" style="margin-top:20px;margin-bottom:30px;">
              <Col :span="16">
                <Row :gutter="16" justify="space-between">
                  <Col :span="12">
                    <Card :padding="0" style="height:400px;" dis-hover>
                      <template #title>
                        新闻公告
                      </template>
                      <template #extra>
                        <a href="#" @click.prevent="more(2)">
                          更多
                        </a>
                      </template>
                      <List>
                        <ListItem v-for="(item, index) in list2" :key="index">
                          <ListItemMeta
                            :title="item.date"
                            :description="item.description"
                          />
                        </ListItem>
                      </List>
                    </Card>
                  </Col>
                  <Col :span="12">
                    <Card :padding="0" style="height:400px;" dis-hover>
                      <template #title>
                        活动推文
                      </template>
                      <template #extra>
                        <a href="#" @click.prevent="more(3)">
                          更多
                        </a>
                      </template>
                      <List>
                        <ListItem v-for="(item, index) in list3" :key="index">
                          <ListItemMeta
                            :title="item.date"
                            :description="item.description"
                          />
                        </ListItem>
                      </List>
                    </Card>
                  </Col>
                </Row>
              </Col>
              <Col :span="8">
                <Card :padding="0" style="overflow: hidden;" dis-hover>
                  <template #title>
                    通讯录
                  </template>
                  <!-- <template #extra>
                        <a href="#" @click.prevent="more(3)">
                            更多
                        </a>
                    </template> -->
                  <List
                    item-layout="vertical"
                    style="overflow-y:scroll;height:355px;"
                  >
                    <ListItem v-for="(item, index) in list4" :key="index">
                      <ListItemMeta :title="item.date" />
                        <Button type="primary" style="margin-right:30px;" to="/bbs">硕士</Button>
                        <Button type="primary" to="/bbs">博士</Button>
                    </ListItem>
                  </List>
                </Card>
              </Col>
            </Row>
          </div>
        </TabPane>
        <TabPane label="资讯" icon="md-list-box" name="news">
          <div class="lis__box">
            此处显示
            {{
              newsType == 0
                ? "全部资讯"
                : newsType == 1
                ? "同门资讯"
                : newsType == 2
                ? "新闻公告"
                : "活动推文"
            }}
            的相关内容
            <br />
            <List size="large">
              <ListItem
                v-for="(item, index) in allNewsList"
                :key="index"
                v-show="item.type == newsType || newsType == 0"
                style="font-size:18px;line-height:1.5em;"
              >
                <span style="font-weight:bolder;">{{
                  item.type == 1
                    ? "同门资讯"
                    : item.type == 2
                    ? "新闻公告"
                    : "活动推文"
                }}</span>
                <span class="newslistsp">{{ item.description }}</span>
                <span>{{ item.date }}</span>
              </ListItem>
            </List>
          </div>
        </TabPane>
        <TabPane label="相册" icon="md-images" name="photos"> </TabPane>
        <TabPane label="服务" icon="md-key" name="service">
          <CellGroup>
            <Cell title="通讯录访问申请" to="" target="_blank"/>
            <Cell title="入校申请" to="" target="_blank"/>
          </CellGroup>
        </TabPane>
        <TabPane label="联系" icon="md-contacts" name="contact">
          <div class="lis_box">
            <span style="font-size:20px;">联系方式：xxxxxxxxxxx</span>
          </div>
        </TabPane>
        <!-- <TabPane label="搜索" icon="ios-construct" name="search"> </TabPane> -->
        <template #extra>
          <Input
            search
            enter-button
            placeholder="输入搜索..."
            @on-search="handleSearch"
          />
        </template>
      </Tabs>
    </div>
  </div>
</template>
<script>
import { Row, Col } from "view-design";

export default {
  name: "Events",
  components: {
    Row,
    Col
  },
  mixins: [],
  props: {},
  data() {
    return {
      newestImg:
        "https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/news1Image.png",
      tabs: ["index", "news", "photos", "service", "contact"],
      currentTabs: "index",
      list1: [
        {
          date: "2021-09-13",
          description: "xxxx组织了xxxxx竣工验收"
        },
        {
          date: "2021-08-13",
          description: "xxxx组织了xxxxx竣工验收"
        },
        {
          date: "2021-07-13",
          description: "xxxx组织了xxxxx竣工验收"
        },
        {
          date: "2021-06-13",
          description: "xxxx组织了xxxxx竣工验收"
        }
        // {
        //   date: '2021-05-13',
        //   description: 'xxxx组织了xxxxx竣工验收'
        // },
      ],
      list2: [
        {
          date: "2021-09-13",
          description: "xxxx准备参加xxxxx会议"
        },
        {
          date: "2021-08-13",
          description: "xxxx准备参加xxxxx会议"
        },
        {
          date: "2021-07-13",
          description: "xxxx准备参加xxxxx会议"
        },
        {
          date: "2021-06-13",
          description: "xxxx准备参加xxxxx会议"
        }
      ],
      list3: [
        {
          date: "2021-09-13",
          description: "xxxx举行了xxxxx会议"
        },
        {
          date: "2021-08-13",
          description: "xxxx开展了xxxxx活动"
        },
        {
          date: "2021-07-13",
          description: "xxxx举行了xxxxx会议"
        },
        {
          date: "2021-06-13",
          description: "xxxx开展了xxxxx活动"
        }
      ],
      list4: [
        {
          date: "2022届"
        },
        {
          date: "2021届"
        },
        {
          date: "2020届"
        },
        {
          date: "2019届"
        },
        {
          date: "2018届"
        },
        {
          date: "2017届"
        },
        {
          date: "2016届"
        },
        {
          date: "2015届"
        }
      ],
      newsType: 0, //0 全部 1 同门资讯 2 新闻公告 3 活动推文,
      newsContent: "",
      allNewsList: [
        {
          date: "2021-09-13",
          description: "xxxx组织了xxxxx竣工验收",
          type: 1
        },
        {
          date: "2021-09-13",
          description: "xxxx准备参加xxxxx会议",
          type: 2
        },
        {
          date: "2021-09-13",
          description: "xxxx举行了xxxxx会议",
          type: 3
        },
        {
          date: "2021-08-13",
          description: "xxxx开展了xxxxx活动",
          type: 3
        },
        {
          date: "2021-08-13",
          description: "xxxx组织了xxxxx竣工验收",
          type: 1
        },
        {
          date: "2021-08-13",
          description: "xxxx准备参加xxxxx会议",
          type: 2
        },
        {
          date: "2021-07-13",
          description: "xxxx组织了xxxxx竣工验收",
          type: 1
        },
        {
          date: "2021-07-13",
          description: "xxxx举行了xxxxx会议",
          type: 3
        },
        {
          date: "2021-07-13",
          description: "xxxx准备参加xxxxx会议",
          type: 2
        },
        {
          date: "2021-06-13",
          description: "xxxx组织了xxxxx竣工验收",
          type: 1
        },
        {
          date: "2021-06-13",
          description: "xxxx准备参加xxxxx会议",
          type: 2
        },
        {
          date: "2021-06-13",
          description: "xxxx开展了xxxxx活动",
          type: 3
        }
      ]
    };
  },
  computed: {},
  created() {
    this.$emit("changeProduce", "events");
  },
  mounted() {},
  methods: {
    tabsChange(e) {
      this.currentTabs = e;
    },
    more(num) {
      if (num === 1) {
        this.newsType = 1;
      } else if (num === 2) {
        this.newsType = 2;
      } else if (num === 3) {
        this.newsType = 3;
      } else {
        this.currentTabs = "index";
        return false;
      }
      this.currentTabs = "news";
    },
    handleSearch(value) {}
  }
};
</script>
<style lang="less" scoped>
.events {
  .top {
    width: 100%;
    height: 280px;
    background: url("https://hjg-officialwebsite.oss-cn-shenzhen.aliyuncs.com/user_bg.png")
      center center no-repeat;
    background-size: 100% 100%;
    // display: flex;
    // flex-direction: column;
    // justify-content: center;
    // align-items: center;
    padding-top: 54px;
    padding-left: 240px;
    font-weight: bold;
    color: #fff;
    .imte__bag {
      font-size: 40px;
      margin-bottom: 32px;
    }

    .imte__min {
      font-size: 24px;
    }
    &__large {
      margin-top: 16px;
      font-size: 24px;
      line-height: 1.5em;
    }
    &__small {
      font-size: 14px;
      line-height: 1.5em;
    }
  }
  .content {
    width: 1300px;
    // height: 500px;
    margin: 30px auto;
    .title__box {
      line-height: 2em;
      margin: 18px 0;
      color: #000;
    }
  }
}
.newslistsp {
  margin: 0 20px;
}
/deep/.ivu-tabs-nav .ivu-tabs-tab {
  font-size: 18px;
  padding: 8px 32px;
}
</style>
